// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import ElementUI from 'element-ui';
import i18n from './lang' // internationalization
import 'element-ui/lib/theme-chalk/index.css';
import VueLuckyCanvas from '@lucky-canvas/vue'
import locale from 'element-ui/lib/locale/lang/zh-TW'
// import axios from 'axios'
// import VueAxios from 'vue-axios'
Vue.use(VueLuckyCanvas)
Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value)
})



Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next();
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js